const links: string[] = [
  '/find-vehicle',
  '/help-me-choose/most-important',
  '/car-finance',
  '/part-exchange',
  '/my-profile',
]

export default links
